import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const SiteShell = ({ children }) => (
  <div className="min-h-screen bg-background text-foreground flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
